export function hasValueList(list: Array<any>): boolean {
  return list && list !== null && list.length > 0;
}

export function firstElementList<T>(list: T[] | null): T | null {
  if (list && list !== null && list.length > 0) {
    return list[0];
  }

  return null;
}

export function lastElementList<T>(list: T[]): T | null {
  if (list && list !== null && list.length > 0) {
    return list[list.length - 1];
  }

  return null;
}

/**
 *
 * @description Check if two arrays are equal
 * @param arr1 First array to compare
 * @param arr2 Second array to compare
 * @param indexKey Key to compare
 * @returns {boolean} Return true if arrays are equal based on key
 * @example
 * const arr1 = [{id: '1', name: 'test'}, {id: '2', name: 'test2'}];
 * const arr2 = [{id: '1', name: 'lorem'}, {id: '2', name: 'lorem2'}];
 *
 * const isEqual = arraysIsEqual(arr1, arr2, 'id');
 * const isEqual2 = arraysIsEqual(arr1, arr2, 'name');
 *
 * console.log(isEqual); // true
 * console.log(isEqual2); // false
 */
export function arraysIsEqual<T>(
  arr1: T[],
  arr2: T[],
  indexKey: keyof T = 'id' as keyof T
) {
  if (arr1.length !== arr2.length) return false;
  const isStringArrays =
    typeof arr1[0] === 'string' && typeof arr2[0] === 'string';

  if (isStringArrays) return arr1.every(item => arr2.includes(item));

  const keysArr2 = arr2.map(item => item[indexKey]);
  return arr1.every(item => keysArr2.includes(item[indexKey]));
}

export function chunkArray(array: any[], chunkSize: number) {
  const chunkedArray = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunkedArray.push(array.slice(i, i + chunkSize));
  }
  return chunkedArray;
}
